import I18n from 'I18n';
import { useCallback, useMemo } from 'react';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { useGetMacrosQuery } from '../../__generated__/chirp/com/hubspot/cv/macros/rpc/MacroRpc.hooks';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { MacrosMenuLoadingState } from './MacrosMenuLoadingState';
import { MacrosMenuList } from './MacrosMenuList';
import { MacrosMenuErrorState } from './MacrosMenuErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenu = ({
  onSelectMacro
}) => {
  const {
    data: macrosData,
    error,
    loading
  } = useGetMacrosQuery();
  const sortedMacros = useMemo(() => {
    if (!(macrosData !== null && macrosData !== void 0 && macrosData.results)) {
      return [];
    }
    return [...macrosData.results].sort((a, b) => a.name.localeCompare(b.name));
  }, [macrosData === null || macrosData === void 0 ? void 0 : macrosData.results]);
  const renderDropdownContent = useCallback(() => {
    if (loading) {
      return /*#__PURE__*/_jsx(MacrosMenuLoadingState, {});
    }
    if (error) {
      return /*#__PURE__*/_jsx(MacrosMenuErrorState, {});
    }
    if (sortedMacros.length > 0) {
      return /*#__PURE__*/_jsx(MacrosMenuList, {
        macros: sortedMacros,
        onSelectMacro: onSelectMacro
      });
    }
  }, [error, loading, sortedMacros, onSelectMacro]);
  const disableDropdown = sortedMacros.length === 0 && !loading;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('composer-ui.macros-menu.no-macros'),
    disabled: !disableDropdown,
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "link",
      buttonText: I18n.text('composer-ui.macros-menu.title'),
      menuWidth: 300,
      paddingInline: "400",
      "data-test-id": "macros-menu-dropdown",
      disabled: disableDropdown,
      children: renderDropdownContent()
    })
  });
};
MacrosMenu.displayName = 'MacrosMenu';